export const optionPowerUp = ["-select-","Emotional", "Physical", "Social", "Mental"];
export const optionschedule = ["one Time", "two Time"];